<mat-form-field
  class="example-chip-list"
  [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'"
>
  <mat-chip-grid #chipGrid [ngClass]="{ 'hide-chips': hideChips }">
    @for (chips of selectedChips; track chips) {
      <mat-chip-row [matTooltip]="showTooltip ? (optionObj ? chips.text : chips) : null" (removed)="remove(chips)">
        {{ optionObj ? chips.text : chips }}
        @if (iconPath) {
          <img class="remove-icon" matChipRemove [src]="iconPath" alt="icon" />
        }
        @if (!iconPath) {
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
  </mat-chip-grid>

  <div class="input-container">
    <input
      #searchInput
      [placeholder]="placeholder"
      [formControl]="inputCtrl"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      (ngModelChange)="onInputValueChanged($event)"
      (mousedown)="userInputChange = true; showInputPlaceholder = false; showOptionsList = true; onFocusAction()"
      (blur)="userInputChange = false; showInputPlaceholder = true"
      [readonly]="disableSearch"
    />
    @if ((inputCtrl.value === null || inputCtrl.value?.length === 0) && showSearchPlaceholder && showInputPlaceholder) {
      <div class="input-search-placeholder">
        {{ getPlaceholderText() | async }}
      </div>
    }

    @if (dropdownIconsPath) {
      <span class="select-arrow" [inlineSVG]="dropdownIconsPath + (showOptionsList ? 'up' : 'down') + '.svg'"></span>
    }
  </div>

  @if (disableHidingList ? true : showOptionsList) {
    <div
      #scrollContainer
      class="manual-options-list"
      (appClickOutside)="onClickOutside($event)"
      [exception]="searchInput"
    >
      @for (option of filteredOptions | async; track option; let last = $last) {
        <div class="manual-option" [ngClass]="{ 'last-item': last }">
          <mat-checkbox [(ngModel)]="option.selected" [checked]="option.selected" (change)="selected(option)">
            {{ optionObj ? option.text : option }}
          </mat-checkbox>
          @if (removeItem && (useRemoveFromOptions ? option.toRemove : true)) {
            <span
              class="remove-icon"
              [inlineSVG]="removeIconPath ? removeIconPath : '/icons/icon-close2.svg'"
              (click)="onRemoveItem(option)"
            ></span>
          }
        </div>
      }
      <div #endOfList></div>
    </div>
  }
</mat-form-field>
